import { Icon } from '@aibees/shared/components/icon';
import { usePathname } from '@aibees/shared/router';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { SwitchTabItemProps as Props } from './types';

export const SwitchTabItem = memo(
  ({ className, item, activeProps, inActiveProps }: Props) => {
    const pathname = usePathname();
    const active = pathname === item.path;

    return (
      <Styled.Wrapper
        className={classnames('SwitchTabItem', className, {
          active,
        })}
        sx={SX.root}
        to={item.path}
        variant="text"
        color="inherit"
        {...(active ? activeProps : inActiveProps)}
      >
        {item.icon && <Icon name={item.icon} size={20} />}
        {item.title}
      </Styled.Wrapper>
    );
  }
);

SwitchTabItem.displayName = 'SwitchTabItem';
